import { render, staticRenderFns } from "./ProductNames.vue?vue&type=template&id=2d3ee3e2&"
import script from "./ProductNames.vue?vue&type=script&lang=js&"
export * from "./ProductNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports